import React, { useState, useEffect } from 'react';
import { Box, Button, makeStyles, Theme } from '@material-ui/core';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { ExternalButton } from '../external-button/ExternalButton';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& .MuiAlert-standardInfo': {
      background: '#fff3e6',
      boxShadow: '0px 3px 5px rgba(52, 61, 75, 0.05)',
    },
  },
}));

export default function CookiePopup() {
  const [open, setOpen] = useState(false);

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    localStorage.setItem('cookieConsent', 'present');
    setOpen(false);
  };

  useEffect(() => {
    const storageState = localStorage.getItem('cookieConsent');
    if (storageState !== 'present') {
      setOpen(true);
    }
  }, []);

  const classes = useStyles();
  return (
    <div data-mobile="none" data-confirm-cookie-section="true">
      <Snackbar open={open} onClose={handleClose} className={classes.root}>
        <Alert severity="info">
          We use cookies on this site to enhance your user experience. By
          clicking the Accept button, you agree to us doing so.
          <br />
          Inspectors are required to enable geolocation functionality prior to
          logging in for an inspection; failure to do so will result in
          discipline pursuant to the DCRA Third-Party Program Procedural Manual.
          <br />
          <ExternalButton to={'/../legal'}>
            More info is available here
          </ExternalButton>
          .
          <br />
          <br />
          <Box display="flex" justifyContent="center">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              onClick={() => handleClose()}
            >
              Accept
            </Button>
          </Box>
        </Alert>
      </Snackbar>
    </div>
  );
}
